/* eslint-disable max-len */
export default {
    title: 'Über uns',
    subtitle:
    '"Lemlock wurde als Antwort auf die steigende Nachfrage nach cyber-sicheren Softwarelösungen gegründet.',
    values: {
        title: 'Werte'
    },
    mission_vision: {
        mission: {
            title: 'Mission',
            text: 'Lemlock stellt sicher , dass die Systeme und Lösungen unserer Kunden unter Berücksichtigung rechtlicher und technischer Aspekte, in angemessener Weise gesichert sind.'
        },
        vision: {
            title: 'Vision',
            text: 'Lemlock möchte das fehlende Bindeglied zwischen den rechtlichen Verfahren und der technischen Überwachung sein, wodurch eine volle Synergie zugunsten unserer Kunden entsteht.'
        },
        verified: {
            text: 'Verified by Lemlock'
        }
    },
    perspectives: {
        title: 'Lemlock - drei Perspektiven bzgl. Cyber-Sicherheit',
        list: [
            {
                image: 'bartlomiej',
                icon: 'hacker',
                occupation:
          '<span class="bold">Perspektive eines Hackers</span><br/> Chief Security Officer',
                name: 'Bartłomiej Balcerek',
                linkedin: 'https://www.linkedin.com/in/bartlomiej-balcerek-4b229a1/'
            },
            {
                image: 'grzegorz',
                icon: 'developer',
                occupation:
          '<span class="bold">Perspektive eines Software-Ingenieurs</span><br/> Systemarchitekt',
                name: 'Grzegorz Mąkosa',
                linkedin: 'https://www.linkedin.com/in/grzegorzmakosa/'
            },
            {
                image: 'marcin',
                icon: 'developer',
                occupation:
          '<span class="bold">Perspektive eines Software-Ingenieurs</span><br/> Systemarchitekt',
                name: 'Marcin Michalski',
                linkedin: 'https://www.linkedin.com/in/marcin-michalski-0053016/'
            }
        ]
    },
    team: {
        title: 'Team',
        subtitle:
      'Das Team von Lemlock besteht aus Sicherheitstestern, Anwälten und Software-Ingenieuren.',
        text: [
            'Ihre Erfahrungen und Kompetenzen im Bereich der Cyber-Sicherheit werden durch zahlreiche Projekte, wissenschaftliche Publikationen und Präsentationen auf nationalen und internationalen Konferenzen wie Secure Poland, Computer Networks - Polen oder MMM-ACNS Russland bestätigt.',
            'Das Auffinden einer Reihe von Schwachstellen in einer häufig verwendeten Software, z.B. <a href="https://cve.mitre.org/cgi-bin/cvename.cgi?name=CVE-2013-1086" target="_blank" rel="noopener noreferrer">CVE-2013-1086</a>, <a href="https://cve.mitre.org/cgi-bin/cvename.cgi?name=CVE-2013-1087" target="_blank" rel="noopener noreferrer">CVE-2013-1087</a> und <a href="https://cve.mitre.org/cgi-bin/cvename.cgi?name=CVE-2015-2802" target="_blank" rel="noopener noreferrer">CVE-2015-2802</a>zeugt vom praktischen Wissen über Sicherheitsprobleme. Jede Tätigkeit wird von der Idee geleitet, ein Unternehmen verantwortungsvoll weiterzuentwickeln und das Bewusstsein für bestehende Bedrohungen im Online- und Offline-Bereich zu erhöhen.'
        ]
    },
    clutch: {
        title: 'SIE VERTRAUEN UNS'
    }
};



// WEBPACK FOOTER //
// ./src/i18n/de/about.js